import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { IonButton, IonButtons, IonList, PopoverController } from '@ionic/angular';
import { Router } from '@angular/router';
import { AppConfiguration, BasePageConfig } from '../../../config/entities';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MenuItemsFilterPipe } from '../../../config/pipes/menu-items-filter.pipe';
import { ConfigService } from '../../../config/services/config.service';
import { CurafidaAuthService } from '../../../authentication/curafida-auth.service';
import { UserRoles } from '../../../user/entities/user-roles';

@Component({
    selector: 'app-popover-menu',
    templateUrl: './popover-menu.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, TranslateModule, IonButton, IonButtons, IonList, MenuItemsFilterPipe],
})
export class PopoverMenuComponent {
    subPages = input<BasePageConfig[]>([]);
    readonly configService = inject(ConfigService);
    appConfig: AppConfiguration;
    authService = inject(CurafidaAuthService);
    protected roles: UserRoles[];
    constructor(
        public router: Router,
        private popoverController: PopoverController,
    ) {
        this.appConfig = this.configService.frontendConfig();
        this.roles = this.authService.loggedInUser().roles;
    }

    openPage(url: string) {
        this.router.navigate([url]);
        this.dismissClick();
    }

    async dismissClick() {
        await this.popoverController.dismiss();
    }
}
